import BreakpointsContainer from '~/components/BreakpointsContainer';
import type { Publication, WebThemeV2 } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import BorderSpacer from '../Nav/BorderSpacer';
import LogoHome from '../Nav/LogoHome';
import Menu from '../Nav/Menu';
import MenuActions from '../Nav/MenuActions';
import MobileDropdown from '../Nav/MobileDropdown';

interface Props {
  publication: Publication;
  isLoggedIn?: boolean;
  subscription?: Subscription;
  isAdminLoggedIn?: boolean;
  showActions: boolean;
  theme: WebThemeV2;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const Template6 = ({ publication, isLoggedIn, subscription, isAdminLoggedIn, showActions, theme }: Props) => {
  return (
    <div className="w-full">
      <BreakpointsContainer
        as="nav"
        className="py-2"
        style={{
          backgroundColor: theme?.navbar_background_color,
        }}
      >
        <div className="mx-auto flex items-center justify-between">
          <div className="w-1/3">
            <MobileDropdown theme={theme} dropdownDirection="left" publication={publication} />
          </div>
          <div className="mx-auto flex w-1/3 justify-center">
            <LogoHome
              url={publication.logo.thumb.url}
              name={publication.name}
              textColor={theme.navbar_text_color}
              fontFamily={theme.navbar_font_family}
            />
          </div>
          <div className="flex w-1/3 justify-end">
            <MenuActions
              hideDropdown={true}
              ctaText={publication.cta_text}
              showActions={showActions}
              publication={publication}
            />
          </div>
        </div>
      </BreakpointsContainer>
      <BorderSpacer color={theme?.navbar_text_color} />
      <BreakpointsContainer
        as="nav"
        className="py-2"
        style={{
          backgroundColor: theme?.navbar_background_color,
        }}
      >
        <div className="mx-auto flex justify-center">
          <Menu publication={publication} theme={theme} />
        </div>
      </BreakpointsContainer>
    </div>
  );
};

export default Template6;
